/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateRepositoryInput = {
  engineerDiagnosticId: string,
};

export type Repository = {
  __typename: "Repository",
  assessmentUrl: string,
};

export type EngineerInput = {
  experience: Experience,
  skillIds: Array< string >,
  cv?: S3ObjectInput | null,
  linkedIn?: string | null,
  utm?: UrchinTrackingModuleInput | null,
};

export enum Experience {
  FROM_0_TO_2 = "FROM_0_TO_2",
  FROM_2_TO_3 = "FROM_2_TO_3",
  FROM_3_TO_5 = "FROM_3_TO_5",
  FROM_5_TO_10 = "FROM_5_TO_10",
  FROM_10_AND_MORE = "FROM_10_AND_MORE",
}


export type S3ObjectInput = {
  bucket: string,
  region: string,
  key: string,
  pathPrefix: string,
};

export type UrchinTrackingModuleInput = {
  source?: string | null,
  medium?: string | null,
  campaign?: string | null,
  term?: string | null,
  content?: string | null,
};

export type Engineer = {
  __typename: "Engineer",
  id: string,
  owner?: string | null,
  experience?: Experience | null,
  positionTitleTypes?: Array< PositionTitleType > | null,
  skillIds: Array< string >,
  cv?: S3Object | null,
  linkedIn?: string | null,
  phase?: EngineerPhase | null,
  utm?: UrchinTrackingModule | null,
  createdAt: string,
  updatedAt: string,
};

export enum PositionTitleType {
  INDIVIDUAL_CONTRIBUTOR = "INDIVIDUAL_CONTRIBUTOR",
  TECHNICAL_MANAGER = "TECHNICAL_MANAGER",
}


export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
  pathPrefix: string,
};

export enum EngineerPhase {
  DIAGNOSTIC = "DIAGNOSTIC",
  MATCHING = "MATCHING",
  HIRED = "HIRED",
}


export type UrchinTrackingModule = {
  __typename: "UrchinTrackingModule",
  source?: string | null,
  medium?: string | null,
  campaign?: string | null,
  term?: string | null,
  content?: string | null,
};

export type JobMatchInput = {
  openPositionId: string,
  interest?: boolean | null,
};

export type JobMatch = {
  __typename: "JobMatch",
  id: string,
  engineerId: string,
  openPositionId: string,
  engineerInterest?: boolean | null,
  status?: JobMatchStatus | null,
  inactiveMatchReason?: InactiveMatchReason | null,
  openPosition: OpenPosition,
  createdAt: string,
  updatedAt: string,
};

export enum JobMatchStatus {
  IN_REVIEW = "IN_REVIEW",
  WAITING_FOR_DIAGNOSTIC = "WAITING_FOR_DIAGNOSTIC",
  COMPANY_CHECK = "COMPANY_CHECK",
  INTERVIEWING = "INTERVIEWING",
  OFFER = "OFFER",
  HIRED = "HIRED",
  NO_GO = "NO_GO",
}


export enum InactiveMatchReason {
  REVIEW = "REVIEW",
  DIAGNOSTIC = "DIAGNOSTIC",
  COMPANY_REVIEW = "COMPANY_REVIEW",
  COMPANY_INTERVIEWS = "COMPANY_INTERVIEWS",
  ENGINEER_WITHDRAWAL = "ENGINEER_WITHDRAWAL",
  COMPANY_INACTIVE = "COMPANY_INACTIVE",
}


export type OpenPosition = {
  __typename: "OpenPosition",
  id: string,
  name: string,
  company: Company,
  titleType: PositionTitleType,
  role: Role,
  active: boolean,
  experience: Experience,
  diagnostics?: ModelOpenPositionDiagnosticConnection | null,
  skills?: ModelOpenPositionSkillConnection | null,
  createdAt: string,
  updatedAt: string,
};

export type Company = {
  __typename: "Company",
  id: string,
  name: string,
  url?: string | null,
  logoUrl?: string | null,
  summary?: string | null,
};

export enum Role {
  BACKEND = "BACKEND",
  FRONTEND = "FRONTEND",
  FULLSTACK = "FULLSTACK",
  MOBILE = "MOBILE",
}


export type ModelOpenPositionDiagnosticConnection = {
  __typename: "ModelOpenPositionDiagnosticConnection",
  items:  Array<OpenPositionDiagnostic | null >,
  nextToken?: string | null,
};

export type OpenPositionDiagnostic = {
  __typename: "OpenPositionDiagnostic",
  id: string,
  openPositionId: string,
  diagnosticId: string,
  diagnostic: DiagnosticActivity,
  position: OpenPosition,
};

export type DiagnosticActivity = {
  __typename: "DiagnosticActivity",
  id: string,
  name: string,
  assessment?: string | null,
  description?: string | null,
  type: DiagnosticType,
  category: string,
  image?: string | null,
  openPositions?: ModelOpenPositionDiagnosticConnection | null,
};

export enum DiagnosticType {
  MEETING = "MEETING",
  INTERVIEW = "INTERVIEW",
  ASSESSMENT = "ASSESSMENT",
  SCREENCAST = "SCREENCAST",
  TECHNICAL_INTERVIEW = "TECHNICAL_INTERVIEW",
  LIVE_CODING_INTERVIEW = "LIVE_CODING_INTERVIEW",
}


export type ModelOpenPositionSkillConnection = {
  __typename: "ModelOpenPositionSkillConnection",
  items:  Array<OpenPositionSkill | null >,
  nextToken?: string | null,
};

export type OpenPositionSkill = {
  __typename: "OpenPositionSkill",
  id: string,
  openPositionId: string,
  skillId: string,
};

export type EngineerDiagnosticInput = {
  diagnosticId: string,
};

export type EngineerDiagnostic = {
  __typename: "EngineerDiagnostic",
  id: string,
  engineerId: string,
  diagnosticId: string,
  order?: number | null,
  assessmentUrl?: string | null,
  canceledAt?: string | null,
  readyAt?: string | null,
  diagnostic: DiagnosticActivity,
  createdAt: string,
  updatedAt: string,
};

export type SkillsDeclarationSkill = {
  __typename: "SkillsDeclarationSkill",
  id: string,
  skillsDeclarationId: string,
  skillId?: string | null,
  skillsDeclaration: SkillsDeclaration,
  createdAt: string,
  updatedAt: string,
  skill?: TechnicalSkill | null,
};

export type SkillsDeclaration = {
  __typename: "SkillsDeclaration",
  id: string,
  backendLevel?: Level | null,
  frontendLevel?: Level | null,
  mobileLevel?: Level | null,
  skills?: ModelSkillsDeclarationSkillConnection | null,
  createdAt: string,
  updatedAt: string,
};

export enum Level {
  JUNIOR = "JUNIOR",
  INTERMEDIATE = "INTERMEDIATE",
  EXPERT = "EXPERT",
}


export type ModelSkillsDeclarationSkillConnection = {
  __typename: "ModelSkillsDeclarationSkillConnection",
  items:  Array<SkillsDeclarationSkill | null >,
  nextToken?: string | null,
};

export type TechnicalSkill = {
  __typename: "TechnicalSkill",
  id: string,
  name: string,
  type?: SkillType | null,
  area: SkillArea,
  active: boolean,
  frequency?: SkillFrequency | null,
  createdAt: string,
  updatedAt: string,
};

export enum SkillType {
  MAIN = "MAIN",
  SECONDARY = "SECONDARY",
}


export enum SkillArea {
  BACKEND = "BACKEND",
  FRONTEND = "FRONTEND",
  MOBILE = "MOBILE",
  OTHER = "OTHER",
}


export enum SkillFrequency {
  FREQUENTLY = "FREQUENTLY",
  OCCASIONALLY = "OCCASIONALLY",
  RARELY = "RARELY",
  UNLIKELY = "UNLIKELY",
}


export type UpdateEngineerInput = {
  id: string,
  owner?: string | null,
  experience?: Experience | null,
  positionTitleTypes?: Array< PositionTitleType > | null,
  skillIds?: Array< string > | null,
  cv?: S3ObjectInput | null,
  linkedIn?: string | null,
  phase?: EngineerPhase | null,
  utm?: UrchinTrackingModuleInput | null,
};

export type ModelEngineerConditionInput = {
  experience?: ModelExperienceInput | null,
  positionTitleTypes?: ModelPositionTitleTypeListInput | null,
  skillIds?: ModelIDInput | null,
  linkedIn?: ModelStringInput | null,
  phase?: ModelEngineerPhaseInput | null,
  and?: Array< ModelEngineerConditionInput | null > | null,
  or?: Array< ModelEngineerConditionInput | null > | null,
  not?: ModelEngineerConditionInput | null,
};

export type ModelExperienceInput = {
  eq?: Experience | null,
  ne?: Experience | null,
};

export type ModelPositionTitleTypeListInput = {
  eq?: Array< PositionTitleType | null > | null,
  ne?: Array< PositionTitleType | null > | null,
  contains?: PositionTitleType | null,
  notContains?: PositionTitleType | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelEngineerPhaseInput = {
  eq?: EngineerPhase | null,
  ne?: EngineerPhase | null,
};

export type EngineerDiagnosticSyncInput = {
  engineerId: string,
  diagnosticId: string,
  order?: number | null,
  assessmentUrl?: string | null,
  canceledAt?: string | null,
  readyAt?: string | null,
};

export type EngineerSyncInput = {
  id: string,
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
  experience?: string | null,
  linkedIn?: string | null,
  skillIds?: Array< string > | null,
  phase?: string | null,
  jobMatchIds?: Array< string > | null,
};

export type JobMatchSyncInput = {
  engineerId: string,
  openPositionId: string,
  engineerInterest?: boolean | null,
  status?: string | null,
  inactiveMatchReason?: string | null,
};

export type JobFuzzyMatch = {
  __typename: "JobFuzzyMatch",
  fullMatch: boolean,
  role?: Role | null,
  titleType?: PositionTitleType | null,
  level?: Level | null,
  skills?:  Array<TechnicalSkill > | null,
  reasonCode?: JobNotMatchedReasonCode | null,
  missingSkills?:  Array<TechnicalSkill > | null,
};

export enum JobNotMatchedReasonCode {
  HIGHER_LEVEL = "HIGHER_LEVEL",
  MISSING_SKILL = "MISSING_SKILL",
}


export type ModelEngineerDiagnosticFilterInput = {
  id?: ModelIDInput | null,
  engineerId?: ModelIDInput | null,
  diagnosticId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  assessmentUrl?: ModelStringInput | null,
  canceledAt?: ModelStringInput | null,
  readyAt?: ModelStringInput | null,
  and?: Array< ModelEngineerDiagnosticFilterInput | null > | null,
  or?: Array< ModelEngineerDiagnosticFilterInput | null > | null,
  not?: ModelEngineerDiagnosticFilterInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelEngineerDiagnosticConnection = {
  __typename: "ModelEngineerDiagnosticConnection",
  items:  Array<EngineerDiagnostic | null >,
  nextToken?: string | null,
};

export type ModelEngineerFilterInput = {
  id?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  experience?: ModelExperienceInput | null,
  positionTitleTypes?: ModelPositionTitleTypeListInput | null,
  skillIds?: ModelIDInput | null,
  linkedIn?: ModelStringInput | null,
  phase?: ModelEngineerPhaseInput | null,
  and?: Array< ModelEngineerFilterInput | null > | null,
  or?: Array< ModelEngineerFilterInput | null > | null,
  not?: ModelEngineerFilterInput | null,
};

export type ModelEngineerConnection = {
  __typename: "ModelEngineerConnection",
  items:  Array<Engineer | null >,
  nextToken?: string | null,
};

export type ModelJobMatchFilterInput = {
  id?: ModelIDInput | null,
  engineerId?: ModelIDInput | null,
  openPositionId?: ModelIDInput | null,
  engineerInterest?: ModelBooleanInput | null,
  status?: ModelJobMatchStatusInput | null,
  inactiveMatchReason?: ModelInactiveMatchReasonInput | null,
  and?: Array< ModelJobMatchFilterInput | null > | null,
  or?: Array< ModelJobMatchFilterInput | null > | null,
  not?: ModelJobMatchFilterInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelJobMatchStatusInput = {
  eq?: JobMatchStatus | null,
  ne?: JobMatchStatus | null,
};

export type ModelInactiveMatchReasonInput = {
  eq?: InactiveMatchReason | null,
  ne?: InactiveMatchReason | null,
};

export type ModelJobMatchConnection = {
  __typename: "ModelJobMatchConnection",
  items:  Array<JobMatch | null >,
  nextToken?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelTechnicalSkillFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelSkillTypeInput | null,
  area?: ModelSkillAreaInput | null,
  active?: ModelBooleanInput | null,
  frequency?: ModelSkillFrequencyInput | null,
  and?: Array< ModelTechnicalSkillFilterInput | null > | null,
  or?: Array< ModelTechnicalSkillFilterInput | null > | null,
  not?: ModelTechnicalSkillFilterInput | null,
};

export type ModelSkillTypeInput = {
  eq?: SkillType | null,
  ne?: SkillType | null,
};

export type ModelSkillAreaInput = {
  eq?: SkillArea | null,
  ne?: SkillArea | null,
};

export type ModelSkillFrequencyInput = {
  eq?: SkillFrequency | null,
  ne?: SkillFrequency | null,
};

export type ModelTechnicalSkillConnection = {
  __typename: "ModelTechnicalSkillConnection",
  items:  Array<TechnicalSkill | null >,
  nextToken?: string | null,
};

export type CreateRepositoryMutationVariables = {
  input: CreateRepositoryInput,
};

export type CreateRepositoryMutation = {
  createRepository?:  {
    __typename: "Repository",
    assessmentUrl: string,
  } | null,
};

export type CreateEngineerMutationVariables = {
  input?: EngineerInput | null,
};

export type CreateEngineerMutation = {
  createEngineer:  {
    __typename: "Engineer",
    id: string,
    owner?: string | null,
    experience?: Experience | null,
    positionTitleTypes?: Array< PositionTitleType > | null,
    skillIds: Array< string >,
    cv?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      pathPrefix: string,
    } | null,
    linkedIn?: string | null,
    phase?: EngineerPhase | null,
    utm?:  {
      __typename: "UrchinTrackingModule",
      source?: string | null,
      medium?: string | null,
      campaign?: string | null,
      term?: string | null,
      content?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  },
};

export type CreateOrUpdateJobMatchMutationVariables = {
  input: JobMatchInput,
};

export type CreateOrUpdateJobMatchMutation = {
  createOrUpdateJobMatch?:  {
    __typename: "JobMatch",
    id: string,
    engineerId: string,
    openPositionId: string,
    engineerInterest?: boolean | null,
    status?: JobMatchStatus | null,
    inactiveMatchReason?: InactiveMatchReason | null,
    openPosition:  {
      __typename: "OpenPosition",
      id: string,
      name: string,
      company:  {
        __typename: "Company",
        id: string,
        name: string,
        url?: string | null,
        logoUrl?: string | null,
        summary?: string | null,
      },
      titleType: PositionTitleType,
      role: Role,
      active: boolean,
      experience: Experience,
      diagnostics?:  {
        __typename: "ModelOpenPositionDiagnosticConnection",
        items:  Array< {
          __typename: "OpenPositionDiagnostic",
          id: string,
          openPositionId: string,
          diagnosticId: string,
          diagnostic:  {
            __typename: "DiagnosticActivity",
            id: string,
            name: string,
            assessment?: string | null,
            description?: string | null,
            type: DiagnosticType,
            category: string,
            image?: string | null,
          },
          position:  {
            __typename: "OpenPosition",
            id: string,
            name: string,
            titleType: PositionTitleType,
            role: Role,
            active: boolean,
            experience: Experience,
            createdAt: string,
            updatedAt: string,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
      skills?:  {
        __typename: "ModelOpenPositionSkillConnection",
        items:  Array< {
          __typename: "OpenPositionSkill",
          id: string,
          openPositionId: string,
          skillId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateOrUpdateEngineerDiagnosticMutationVariables = {
  input: EngineerDiagnosticInput,
};

export type CreateOrUpdateEngineerDiagnosticMutation = {
  createOrUpdateEngineerDiagnostic?:  {
    __typename: "EngineerDiagnostic",
    id: string,
    engineerId: string,
    diagnosticId: string,
    order?: number | null,
    assessmentUrl?: string | null,
    canceledAt?: string | null,
    readyAt?: string | null,
    diagnostic:  {
      __typename: "DiagnosticActivity",
      id: string,
      name: string,
      assessment?: string | null,
      description?: string | null,
      type: DiagnosticType,
      category: string,
      image?: string | null,
      openPositions?:  {
        __typename: "ModelOpenPositionDiagnosticConnection",
        items:  Array< {
          __typename: "OpenPositionDiagnostic",
          id: string,
          openPositionId: string,
          diagnosticId: string,
          diagnostic:  {
            __typename: "DiagnosticActivity",
            id: string,
            name: string,
            assessment?: string | null,
            description?: string | null,
            type: DiagnosticType,
            category: string,
            image?: string | null,
          },
          position:  {
            __typename: "OpenPosition",
            id: string,
            name: string,
            titleType: PositionTitleType,
            role: Role,
            active: boolean,
            experience: Experience,
            createdAt: string,
            updatedAt: string,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type BatchCreateSkillsDeclarationSkillsMutationVariables = {
  skillsDeclarationId: string,
  skillIds: Array< string >,
};

export type BatchCreateSkillsDeclarationSkillsMutation = {
  batchCreateSkillsDeclarationSkills?:  Array< {
    __typename: "SkillsDeclarationSkill",
    id: string,
    skillsDeclarationId: string,
    skillId?: string | null,
    skillsDeclaration:  {
      __typename: "SkillsDeclaration",
      id: string,
      backendLevel?: Level | null,
      frontendLevel?: Level | null,
      mobileLevel?: Level | null,
      skills?:  {
        __typename: "ModelSkillsDeclarationSkillConnection",
        items:  Array< {
          __typename: "SkillsDeclarationSkill",
          id: string,
          skillsDeclarationId: string,
          skillId?: string | null,
          skillsDeclaration:  {
            __typename: "SkillsDeclaration",
            id: string,
            backendLevel?: Level | null,
            frontendLevel?: Level | null,
            mobileLevel?: Level | null,
            createdAt: string,
            updatedAt: string,
          },
          createdAt: string,
          updatedAt: string,
          skill?:  {
            __typename: "TechnicalSkill",
            id: string,
            name: string,
            type?: SkillType | null,
            area: SkillArea,
            active: boolean,
            frequency?: SkillFrequency | null,
            createdAt: string,
            updatedAt: string,
          } | null,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
    skill?:  {
      __typename: "TechnicalSkill",
      id: string,
      name: string,
      type?: SkillType | null,
      area: SkillArea,
      active: boolean,
      frequency?: SkillFrequency | null,
      createdAt: string,
      updatedAt: string,
    } | null,
  } | null > | null,
};

export type UpdateEngineerMutationVariables = {
  input: UpdateEngineerInput,
  condition?: ModelEngineerConditionInput | null,
};

export type UpdateEngineerMutation = {
  updateEngineer?:  {
    __typename: "Engineer",
    id: string,
    owner?: string | null,
    experience?: Experience | null,
    positionTitleTypes?: Array< PositionTitleType > | null,
    skillIds: Array< string >,
    cv?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      pathPrefix: string,
    } | null,
    linkedIn?: string | null,
    phase?: EngineerPhase | null,
    utm?:  {
      __typename: "UrchinTrackingModule",
      source?: string | null,
      medium?: string | null,
      campaign?: string | null,
      term?: string | null,
      content?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type SyncEngineerDiagnosticMutationVariables = {
  input?: EngineerDiagnosticSyncInput | null,
};

export type SyncEngineerDiagnosticMutation = {
  syncEngineerDiagnostic?: boolean | null,
};

export type SyncEngineerMutationVariables = {
  input?: EngineerSyncInput | null,
};

export type SyncEngineerMutation = {
  syncEngineer?: boolean | null,
};

export type SyncJobMatchMutationVariables = {
  input?: JobMatchSyncInput | null,
};

export type SyncJobMatchMutation = {
  syncJobMatch?: boolean | null,
};

export type PotentialOpenPositionMatchesQueryVariables = {
};

export type PotentialOpenPositionMatchesQuery = {
  potentialOpenPositionMatches:  Array< {
    __typename: "OpenPosition",
    id: string,
    name: string,
    company:  {
      __typename: "Company",
      id: string,
      name: string,
      url?: string | null,
      logoUrl?: string | null,
      summary?: string | null,
    },
    titleType: PositionTitleType,
    role: Role,
    active: boolean,
    experience: Experience,
    diagnostics?:  {
      __typename: "ModelOpenPositionDiagnosticConnection",
      items:  Array< {
        __typename: "OpenPositionDiagnostic",
        id: string,
        openPositionId: string,
        diagnosticId: string,
        diagnostic:  {
          __typename: "DiagnosticActivity",
          id: string,
          name: string,
          assessment?: string | null,
          description?: string | null,
          type: DiagnosticType,
          category: string,
          image?: string | null,
          openPositions?:  {
            __typename: "ModelOpenPositionDiagnosticConnection",
            nextToken?: string | null,
          } | null,
        },
        position:  {
          __typename: "OpenPosition",
          id: string,
          name: string,
          company:  {
            __typename: "Company",
            id: string,
            name: string,
            url?: string | null,
            logoUrl?: string | null,
            summary?: string | null,
          },
          titleType: PositionTitleType,
          role: Role,
          active: boolean,
          experience: Experience,
          diagnostics?:  {
            __typename: "ModelOpenPositionDiagnosticConnection",
            nextToken?: string | null,
          } | null,
          skills?:  {
            __typename: "ModelOpenPositionSkillConnection",
            nextToken?: string | null,
          } | null,
          createdAt: string,
          updatedAt: string,
        },
      } | null >,
      nextToken?: string | null,
    } | null,
    skills?:  {
      __typename: "ModelOpenPositionSkillConnection",
      items:  Array< {
        __typename: "OpenPositionSkill",
        id: string,
        openPositionId: string,
        skillId: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } >,
};

export type ListMainSkillsWithOpenPositionsQueryVariables = {
  maxExperience?: Experience | null,
};

export type ListMainSkillsWithOpenPositionsQuery = {
  listMainSkillsWithOpenPositions:  Array< {
    __typename: "TechnicalSkill",
    id: string,
    name: string,
    type?: SkillType | null,
    area: SkillArea,
    active: boolean,
    frequency?: SkillFrequency | null,
    createdAt: string,
    updatedAt: string,
  } >,
};

export type JobMatchesSummaryQueryVariables = {
};

export type JobMatchesSummaryQuery = {
  jobMatchesSummary:  Array< {
    __typename: "JobFuzzyMatch",
    fullMatch: boolean,
    role?: Role | null,
    titleType?: PositionTitleType | null,
    level?: Level | null,
    skills?:  Array< {
      __typename: "TechnicalSkill",
      id: string,
      name: string,
      type?: SkillType | null,
      area: SkillArea,
      active: boolean,
      frequency?: SkillFrequency | null,
      createdAt: string,
      updatedAt: string,
    } > | null,
    reasonCode?: JobNotMatchedReasonCode | null,
    missingSkills?:  Array< {
      __typename: "TechnicalSkill",
      id: string,
      name: string,
      type?: SkillType | null,
      area: SkillArea,
      active: boolean,
      frequency?: SkillFrequency | null,
      createdAt: string,
      updatedAt: string,
    } > | null,
  } >,
};

export type GetEngineerDiagnosticQueryVariables = {
  id: string,
};

export type GetEngineerDiagnosticQuery = {
  getEngineerDiagnostic?:  {
    __typename: "EngineerDiagnostic",
    id: string,
    engineerId: string,
    diagnosticId: string,
    order?: number | null,
    assessmentUrl?: string | null,
    canceledAt?: string | null,
    readyAt?: string | null,
    diagnostic:  {
      __typename: "DiagnosticActivity",
      id: string,
      name: string,
      assessment?: string | null,
      description?: string | null,
      type: DiagnosticType,
      category: string,
      image?: string | null,
      openPositions?:  {
        __typename: "ModelOpenPositionDiagnosticConnection",
        items:  Array< {
          __typename: "OpenPositionDiagnostic",
          id: string,
          openPositionId: string,
          diagnosticId: string,
          diagnostic:  {
            __typename: "DiagnosticActivity",
            id: string,
            name: string,
            assessment?: string | null,
            description?: string | null,
            type: DiagnosticType,
            category: string,
            image?: string | null,
          },
          position:  {
            __typename: "OpenPosition",
            id: string,
            name: string,
            titleType: PositionTitleType,
            role: Role,
            active: boolean,
            experience: Experience,
            createdAt: string,
            updatedAt: string,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEngineerDiagnosticsQueryVariables = {
  filter?: ModelEngineerDiagnosticFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEngineerDiagnosticsQuery = {
  listEngineerDiagnostics?:  {
    __typename: "ModelEngineerDiagnosticConnection",
    items:  Array< {
      __typename: "EngineerDiagnostic",
      id: string,
      engineerId: string,
      diagnosticId: string,
      order?: number | null,
      assessmentUrl?: string | null,
      canceledAt?: string | null,
      readyAt?: string | null,
      diagnostic:  {
        __typename: "DiagnosticActivity",
        id: string,
        name: string,
        assessment?: string | null,
        description?: string | null,
        type: DiagnosticType,
        category: string,
        image?: string | null,
        openPositions?:  {
          __typename: "ModelOpenPositionDiagnosticConnection",
          items:  Array< {
            __typename: "OpenPositionDiagnostic",
            id: string,
            openPositionId: string,
            diagnosticId: string,
          } | null >,
          nextToken?: string | null,
        } | null,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetEngineerQueryVariables = {
  id: string,
};

export type GetEngineerQuery = {
  getEngineer?:  {
    __typename: "Engineer",
    id: string,
    owner?: string | null,
    experience?: Experience | null,
    positionTitleTypes?: Array< PositionTitleType > | null,
    skillIds: Array< string >,
    cv?:  {
      __typename: "S3Object",
      bucket: string,
      region: string,
      key: string,
      pathPrefix: string,
    } | null,
    linkedIn?: string | null,
    phase?: EngineerPhase | null,
    utm?:  {
      __typename: "UrchinTrackingModule",
      source?: string | null,
      medium?: string | null,
      campaign?: string | null,
      term?: string | null,
      content?: string | null,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListEngineersQueryVariables = {
  filter?: ModelEngineerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEngineersQuery = {
  listEngineers?:  {
    __typename: "ModelEngineerConnection",
    items:  Array< {
      __typename: "Engineer",
      id: string,
      owner?: string | null,
      experience?: Experience | null,
      positionTitleTypes?: Array< PositionTitleType > | null,
      skillIds: Array< string >,
      cv?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        pathPrefix: string,
      } | null,
      linkedIn?: string | null,
      phase?: EngineerPhase | null,
      utm?:  {
        __typename: "UrchinTrackingModule",
        source?: string | null,
        medium?: string | null,
        campaign?: string | null,
        term?: string | null,
        content?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetJobMatchQueryVariables = {
  id: string,
};

export type GetJobMatchQuery = {
  getJobMatch?:  {
    __typename: "JobMatch",
    id: string,
    engineerId: string,
    openPositionId: string,
    engineerInterest?: boolean | null,
    status?: JobMatchStatus | null,
    inactiveMatchReason?: InactiveMatchReason | null,
    openPosition:  {
      __typename: "OpenPosition",
      id: string,
      name: string,
      company:  {
        __typename: "Company",
        id: string,
        name: string,
        url?: string | null,
        logoUrl?: string | null,
        summary?: string | null,
      },
      titleType: PositionTitleType,
      role: Role,
      active: boolean,
      experience: Experience,
      diagnostics?:  {
        __typename: "ModelOpenPositionDiagnosticConnection",
        items:  Array< {
          __typename: "OpenPositionDiagnostic",
          id: string,
          openPositionId: string,
          diagnosticId: string,
          diagnostic:  {
            __typename: "DiagnosticActivity",
            id: string,
            name: string,
            assessment?: string | null,
            description?: string | null,
            type: DiagnosticType,
            category: string,
            image?: string | null,
          },
          position:  {
            __typename: "OpenPosition",
            id: string,
            name: string,
            titleType: PositionTitleType,
            role: Role,
            active: boolean,
            experience: Experience,
            createdAt: string,
            updatedAt: string,
          },
        } | null >,
        nextToken?: string | null,
      } | null,
      skills?:  {
        __typename: "ModelOpenPositionSkillConnection",
        items:  Array< {
          __typename: "OpenPositionSkill",
          id: string,
          openPositionId: string,
          skillId: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    },
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListJobMatchsQueryVariables = {
  filter?: ModelJobMatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJobMatchsQuery = {
  listJobMatchs?:  {
    __typename: "ModelJobMatchConnection",
    items:  Array< {
      __typename: "JobMatch",
      id: string,
      engineerId: string,
      openPositionId: string,
      engineerInterest?: boolean | null,
      status?: JobMatchStatus | null,
      inactiveMatchReason?: InactiveMatchReason | null,
      openPosition:  {
        __typename: "OpenPosition",
        id: string,
        name: string,
        company:  {
          __typename: "Company",
          id: string,
          name: string,
          url?: string | null,
          logoUrl?: string | null,
          summary?: string | null,
        },
        titleType: PositionTitleType,
        role: Role,
        active: boolean,
        experience: Experience,
        diagnostics?:  {
          __typename: "ModelOpenPositionDiagnosticConnection",
          items:  Array< {
            __typename: "OpenPositionDiagnostic",
            id: string,
            openPositionId: string,
            diagnosticId: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        skills?:  {
          __typename: "ModelOpenPositionSkillConnection",
          items:  Array< {
            __typename: "OpenPositionSkill",
            id: string,
            openPositionId: string,
            skillId: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListEngineersByOwnerQueryVariables = {
  owner?: string | null,
  id?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelEngineerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListEngineersByOwnerQuery = {
  listEngineersByOwner?:  {
    __typename: "ModelEngineerConnection",
    items:  Array< {
      __typename: "Engineer",
      id: string,
      owner?: string | null,
      experience?: Experience | null,
      positionTitleTypes?: Array< PositionTitleType > | null,
      skillIds: Array< string >,
      cv?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
        pathPrefix: string,
      } | null,
      linkedIn?: string | null,
      phase?: EngineerPhase | null,
      utm?:  {
        __typename: "UrchinTrackingModule",
        source?: string | null,
        medium?: string | null,
        campaign?: string | null,
        term?: string | null,
        content?: string | null,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ListJobMatchesByEngineerQueryVariables = {
  engineerId?: string | null,
  openPositionId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJobMatchFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJobMatchesByEngineerQuery = {
  listJobMatchesByEngineer?:  {
    __typename: "ModelJobMatchConnection",
    items:  Array< {
      __typename: "JobMatch",
      id: string,
      engineerId: string,
      openPositionId: string,
      engineerInterest?: boolean | null,
      status?: JobMatchStatus | null,
      inactiveMatchReason?: InactiveMatchReason | null,
      openPosition:  {
        __typename: "OpenPosition",
        id: string,
        name: string,
        company:  {
          __typename: "Company",
          id: string,
          name: string,
          url?: string | null,
          logoUrl?: string | null,
          summary?: string | null,
        },
        titleType: PositionTitleType,
        role: Role,
        active: boolean,
        experience: Experience,
        diagnostics?:  {
          __typename: "ModelOpenPositionDiagnosticConnection",
          items:  Array< {
            __typename: "OpenPositionDiagnostic",
            id: string,
            openPositionId: string,
            diagnosticId: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        skills?:  {
          __typename: "ModelOpenPositionSkillConnection",
          items:  Array< {
            __typename: "OpenPositionSkill",
            id: string,
            openPositionId: string,
            skillId: string,
          } | null >,
          nextToken?: string | null,
        } | null,
        createdAt: string,
        updatedAt: string,
      },
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetTechnicalSkillQueryVariables = {
  id: string,
};

export type GetTechnicalSkillQuery = {
  getTechnicalSkill?:  {
    __typename: "TechnicalSkill",
    id: string,
    name: string,
    type?: SkillType | null,
    area: SkillArea,
    active: boolean,
    frequency?: SkillFrequency | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListTechnicalSkillsQueryVariables = {
  filter?: ModelTechnicalSkillFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListTechnicalSkillsQuery = {
  listTechnicalSkills?:  {
    __typename: "ModelTechnicalSkillConnection",
    items:  Array< {
      __typename: "TechnicalSkill",
      id: string,
      name: string,
      type?: SkillType | null,
      area: SkillArea,
      active: boolean,
      frequency?: SkillFrequency | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};
